export { Icon, type IconProps } from './icon';
export type { IconName } from './icon-paths';
